import DoorConfigFieldRenderer from "./DoorConfigFieldRenderer";

export default function ConfigFormRow({ field, form, onChange }) {
    return (
        <div className="config-form-row">
            <label className="config-form-row__label">{field.label}</label>
            <div className="config-form-row__control">
                <DoorConfigFieldRenderer field={field} form={form} onChange={onChange} />
            </div>
            {field.hint ? <p className="config-form-row__hint">{field.hint}</p> : null}
        </div>
    );
}
